import { render, staticRenderFns } from "./DocumentSignature.vue?vue&type=template&id=16836fe2&scoped=true"
import script from "./DocumentSignature.vue?vue&type=script&lang=js"
export * from "./DocumentSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16836fe2",
  null
  
)

export default component.exports